//
import ProdutoNoPedido from '../../shared/entity/ProdutoNoPedido';
import { formatarDinheiro } from '../../shared/helper';
import { useNavigation } from '@react-navigation/native';
import React, { useState } from 'react';
import { StyleSheet, Text, View } from 'react-native';
import Collapsible from 'react-native-collapsible';
import { Button, Dialog, IconButton, Paragraph, Portal } from 'react-native-paper';
import colors from '../../colors';
import { TXT_M, TXT_P, TXT_PP } from '../../constants';
import { useProdutosNoPedido } from '../../redux/pedido/pedidoHooks';
import CModal from '../Generic/CModal';
import Touchable from '../Generic/Touchable';
import ItemPergunta from './ItemPergunta';

type Props = {
  produto: ProdutoNoPedido;
  index: number;
  bloquearAcoes?: boolean;
};

const MARGIN_LEFT = 24;

const ItemProdutoNoPedido: React.FC<Props> = (props) => {
  const { produto, index, bloquearAcoes } = props;
  const navigation = useNavigation();
  const [openAction, setOpenAction] = useState(false);
  const [modalDeletar, setModalDeletar] = useState(false);
  const [
    adicionarProdutoNoPedido,
    removerProdutoNoPedido,
    editarProdutoNoPedido
  ] = useProdutosNoPedido();

  const deletar = () => {
    removerProdutoNoPedido(index);
    setModalDeletar(false);
  };

  const onClickEditar = () => {
    navigation.navigate('AdicionarProdutoPage', { id: produto.produtoId, editIndex: index });
  };

  return (
    <View>
      <CModal mostrarModal={modalDeletar} onClose={() => setModalDeletar(false)}>
        <Dialog.Title>Ah não :(</Dialog.Title>
        <Dialog.Content>
          <Paragraph>Tem certeza que deseja remover esse produto do seu pedido?</Paragraph>
        </Dialog.Content>
        <Dialog.Actions style={{ justifyContent: 'space-around' }}>
          <Button onPress={() => setModalDeletar(false)}>Voltar</Button>
          <Button onPress={deletar} mode="contained" color={colors.red}>
            REMOVER
          </Button>
        </Dialog.Actions>
      </CModal>

      <Touchable disabled={bloquearAcoes} onPress={() => setOpenAction(!openAction)}>
        <View style={styles.container}>
          <View style={styles.row}>
            <View style={{ flexDirection: 'row' }}>
              <Text style={styles.tituloPreco}>{produto.quantidadeNoPedido}x </Text>
              <Text style={styles.titulo}>{produto.nome}</Text>
            </View>

            <View style={{ flexDirection: 'row' }}>
              <Text
                style={
                  produto.tamanhoSelecionado.precoPromocional > 0
                    ? styles.tituloPrecoInativado
                    : styles.tituloPreco
                }
              >
                R$ {formatarDinheiro(produto.quantidadeNoPedido * produto.tamanhoSelecionado.preco)}
              </Text>
              {produto.tamanhoSelecionado.precoPromocional > 0 && (
                <Text style={[styles.tituloPreco, { marginLeft: 5 }]}>
                  R${' '}
                  {formatarDinheiro(
                    produto.quantidadeNoPedido * produto.tamanhoSelecionado.precoPromocional
                  )}
                </Text>
              )}
            </View>
          </View>

          <View style={{ marginTop: 5, marginLeft: MARGIN_LEFT }}>
            <Text style={styles.txtPergunta}>Tamanho: {produto.tamanhoSelecionado.descricao}</Text>
          </View>

          {produto.perguntasNoPedido &&
            produto.perguntasNoPedido.map((pergunta, i) => (
              <ItemPergunta
                key={`add-${i}`}
                pergunta={pergunta}
                marginLeft={MARGIN_LEFT}
                quantidadeProduto={produto.quantidadeNoPedido}
              />
            ))}

          {Boolean(produto.observacao) && (
            <Text style={{ marginLeft: MARGIN_LEFT, marginTop: 5 }}>
              Obs.: {produto.observacao}
            </Text>
          )}
        </View>
      </Touchable>

      <Collapsible collapsed={!openAction}>
        <View style={styles.triangulo} />
        <View style={styles.viewActions}>
          <IconButton icon="pencil" color={colors.primary} size={20} onPress={onClickEditar} />
          <IconButton
            icon="delete"
            color={colors.primary}
            size={20}
            onPress={() => setModalDeletar(true)}
          />
        </View>
      </Collapsible>
    </View>
  );
};

const styles = StyleSheet.create({
  container: {
    backgroundColor: '#fff',
    width: '100%',

    marginBottom: 15
  },
  titulo: {
    fontSize: TXT_M,
    fontWeight: '500',
    color: colors.primary
  },
  tituloPreco: {
    fontSize: TXT_M,
    fontWeight: '500',
    color: colors.values
  },
  tituloPrecoInativado: {
    fontSize: TXT_P,
    fontWeight: '500',
    color: colors.darkGrey,
    textDecorationLine: 'line-through'
  },
  txtPergunta: {
    fontSize: TXT_P,
    fontWeight: '500'
  },
  txtResposta: {
    fontSize: TXT_PP,
    fontWeight: '500'
  },
  row: { flexDirection: 'row', flex: 1, justifyContent: 'space-between', alignItems: 'center' },
  value: { color: colors.values, fontSize: TXT_PP },
  viewActions: {
    flexDirection: 'row',
    justifyContent: 'space-around',
    backgroundColor: colors.veryLightGrey,
    borderRadius: 5,
    marginBottom: 5
  },
  triangulo: {
    width: 0,
    height: 0,
    backgroundColor: 'transparent',
    borderStyle: 'solid',
    borderLeftWidth: 5,
    borderRightWidth: 5,
    borderBottomWidth: 7,
    borderLeftColor: 'transparent',
    borderRightColor: 'transparent',
    borderBottomColor: colors.veryLightGrey,
    alignSelf: 'center'
  }
});

export default ItemProdutoNoPedido;
